export enum FeatureEntitlements {
  LifecycleCRM = 'whitelabel_lifecycle_crm',
}
